import { configStore } from 'config/configStore';

export const getIsSegmentedRegionSelected  = (() => {
  const { label, EditMode } = configStore.get();
  let values = Object.values(label) as boolean[];

  if (EditMode === 'lumen') {
    const { lumen,lumenoutline, ...labelsWithoutLumen } = label;
    values = Object.values(labelsWithoutLumen) as boolean[];
  }

  return !(values.length > 0 && values.every(Boolean));
});
